// extracted by mini-css-extract-plugin
module.exports = {"container":"TagsComponent_container__2KigC","description":"TagsComponent_description__2zk14"};